import _classPrivateMethodInitSpec from "@babel/runtime/helpers/classPrivateMethodInitSpec";
import _classPrivateFieldInitSpec from "@babel/runtime/helpers/classPrivateFieldInitSpec";
import _assertClassBrand from "@babel/runtime/helpers/assertClassBrand";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet2";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet2";
var _ReactNextElement;
import React from "react";
import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import { NextElement, supportsAdoptingStyleSheets } from "@next-core/element";
var _root = /*#__PURE__*/new WeakMap();
var _ReactNextElement_brand = /*#__PURE__*/new WeakSet();
export class ReactNextElement extends NextElement {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _ReactNextElement_brand);
    _classPrivateFieldInitSpec(this, _root, void 0);
  }
  connectedCallback() {
    super._markConnectedCallbackCalled();
    _assertClassBrand(_ReactNextElement_brand, this, _createRoot).call(this);
    this._render();
  }
  disconnectedCallback() {
    var _classPrivateFieldGet2;
    (_classPrivateFieldGet2 = _classPrivateFieldGet(_root, this)) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.render(null);
  }
  _render() {
    const render = () => {
      if (!this.isConnected || !_classPrivateFieldGet(_root, this)) {
        return;
      }
      const ctor = this.constructor;
      if (ctor.shadowOptions) {
        var _ctor$styleTexts;
        _classPrivateFieldGet(_root, this).render(supportsAdoptingStyleSheets() || !((_ctor$styleTexts = ctor.styleTexts) !== null && _ctor$styleTexts !== void 0 && _ctor$styleTexts.length) ? this.render() : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, ctor.styleTexts.join("\n")), this.render()));
      } else {
        _classPrivateFieldGet(_root, this).render(this.render());
      }
    };

    // In brick next container, enable flush sync for the initial mount of
    // each page, in order to avoid menu flickering.
    // Otherwise, avoid using flush sync as possible.
    if (window.BRICK_NEXT_VERSIONS && !window.DISABLE_REACT_FLUSH_SYNC) {
      flushSync(render);
    } else {
      render();
    }
  }
}
_ReactNextElement = ReactNextElement;
function _createRoot() {
  if (_classPrivateFieldGet(_root, this)) {
    return;
  }
  const ctor = this.constructor;
  if (ctor.shadowOptions) {
    const shadowRoot = this.attachShadow(ctor.shadowOptions);
    if (supportsAdoptingStyleSheets()) {
      var _ctor$styleTexts2;
      if ((_ctor$styleTexts2 = ctor.styleTexts) !== null && _ctor$styleTexts2 !== void 0 && _ctor$styleTexts2.length) {
        const styleSheet = new CSSStyleSheet();
        styleSheet.replaceSync(ctor.styleTexts.join(""));
        shadowRoot.adoptedStyleSheets = [styleSheet];
      }
    }
    _classPrivateFieldSet(_root, this, createRoot(shadowRoot));
  } else {
    var _ctor$styleTexts3;
    if (process.env.NODE_ENV !== "production" && (_ctor$styleTexts3 = ctor.styleTexts) !== null && _ctor$styleTexts3 !== void 0 && _ctor$styleTexts3.length) {
      throw new Error("Use `styleTexts` with `shadowOptions: false` is not supported");
    }
    _classPrivateFieldSet(_root, this, createRoot(this));
  }
}
//# sourceMappingURL=ReactNextElement.js.map